const variant = require("./env.variant").default || 'release'; // release or debug

if (__DEV__) {
  module.exports = require("./env.dev")
} else {
  if (variant === 'release') {
    module.exports = require("./env.prod")
  } else {
    module.exports = require("./env.dev")
  }
}
